import { render, staticRenderFns } from "./NewsletterInputText.vue?vue&type=template&id=8ba4228e&scoped=true"
import script from "./NewsletterInputText.vue?vue&type=script&lang=js"
export * from "./NewsletterInputText.vue?vue&type=script&lang=js"
import style0 from "./NewsletterInputText.vue?vue&type=style&index=0&id=8ba4228e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba4228e",
  null
  
)

export default component.exports